/* ----------------------------------------
    Vue
---------------------------------------- */

import Vue from 'vue';
import App from '@/App.vue';
import router from '@router/router';
import store from '@store/store';
import VeeValidate, { Validator } from 'vee-validate';
import FruitPackage from '@fruitpackage';
import AppPlugin from '@plugin/app';
import VueMask from 'v-mask';
import VueMoney from 'v-money';

/* ----------------------------------------
    Vue Configuration
---------------------------------------- */

Vue.config.productionTip = false;
Vue.config.devtools = true;

/* ----------------------------------------
    Vue Plugins
---------------------------------------- */

Vue.use(VeeValidate);
Vue.use(VueMask);
Vue.use(VueMoney)
Vue.use(FruitPackage);
Vue.use(AppPlugin);

/* ----------------------------------------
    Vue Data
---------------------------------------- */

const env = {
    type: process.env.NODE_ENV,
    baseUrl: process.env.VUE_APP_BASE_URL,
};

const path = {
    start: window.location.pathname
};

const log = {
    type: process.env.LOGNAME
};

/* ----------------------------------------
    Vue Filters
---------------------------------------- */

import './filters/filters';

/* ----------------------------------------
    Vue Registration
---------------------------------------- */

import './service/Registration';

/* ----------------------------------------
    Vue Validation
---------------------------------------- */

import '@fruitpackage/validation/iban';
import '@fruitpackage/validation/password';
import '@fruitpackage/validation/dutch-postal';
import '@fruitpackage/validation/dutch-phone';
import '@fruitpackage/validation/minimal-age';
import '@fruitpackage/validation/terms';
import '@fruitpackage/validation/kvk';

/* ----------------------------------------
    Localize
---------------------------------------- */

import nl from '@translate/form-errors';

Validator.localize('nl', nl);

/* ----------------------------------------
    Initiate Vue
---------------------------------------- */

new Vue({
    el: '#app',
    data: {
        path: path,
        env: env,
        log: log,
        public: true,
    },
    router,
    store,
    render: app => app(App)
});

/* ----------------------------------------
    Set Bugherd
---------------------------------------- */

import { Bugherd } from '@helpers/Bugherd';
new Bugherd();